import * as Sentry from '@sentry/react';
import { REGIONAL_OCTO_DEVSITE_ID, Region } from 'shared/models/regions';
import { IL4_MODE, TOGGLE_SENTRY } from 'config/toggles';
import { clearAllCookies } from 'modules/common/DevsiteCookies';
import { clearGraphiqlSessionStorage, clearLocalStorage } from 'modules/common/util/DevsiteLocalStorage';
import DevsiteEnv from '../DevsiteEnv';

export const navbarHeight = IL4_MODE ? 100 : 64; // account for classification banner height when in IL4 env
export const adminNavbarHeight = 64;

export const executeLogoutCleanup = () => {
  if (TOGGLE_SENTRY) Sentry.setUser(null);
  clearAllCookies();
  clearLocalStorage();
  clearGraphiqlSessionStorage();
};

// The US region (scylla:us) uses the OCTO_DEVSITE_ID from env, which is '372'.
// Any other region, including EU & Federal, uses '1', the default devsite API Client ID for new envs.
export const getOctoDevsiteId = (region: string): number =>
  region !== Region.US ? REGIONAL_OCTO_DEVSITE_ID : Number(DevsiteEnv.OCTO_DEVSITE_ID);
